<template>
  <div>
    <v-row class="ma-0">
      <v-col cols="12">
        <h2 class="primary--text font-weight-bold pt-5 pl-2">
          <v-icon color="primary" large left>
          </v-icon>
          {{ $t('display/logs:email-log.title') }}
        </h2>

        <DataTablePaginated
          ref="table"
          class="ma-1"
          :headers="headers"
          icon="preview"
          @clickedButton1="showDetails"
          @updateTableData="updateTable"
          :addBtn="false"
          sortBy="createdAt"
          sort-desc
          @cacheCommit="$store.commit('display/logs/logsSearchUpdate', {searchTerm:$event, searchType: 'email'})"
          :cachedSearch="$store.state.display.logs.emailLogsSearch"
          :customPanel="createPanel()"
          :trueFalseDecorateFields="trueFalseDecorateFields"
        />
      </v-col>
    </v-row>

    <DetailInfoWindow
      ref="dialogShow" />

  </div>
</template>

<script>
import DataTablePaginated from '@/modules/core/components/DataTable/DataTablePaginated';
import LogsService from '@/modules/display/services/logs-service';
import TablePanel from "@/modules/display/views/logs/TablePanel";
import DataUtils from '@/modules/core/services/data-utils';
import Log from "@/modules/display/data/log";
import Utils from '@/modules/core/services/utils';
import Vue from "vue";
import {i18n} from '@/plugins/i18next';
import DetailInfoWindow from "./email-log/DetailInfoWindow";

export default {
  name: "EmailTable",
  components: {
    DetailInfoWindow,
    DataTablePaginated
  },
  data() {
    return {
      filterHours: true
    };
  },
  computed: {
    headers() {
      return [
        { text: this.$t('common:date'), value: 'createdAt' },
        { text: this.$t('common:status'), value: 'status' },
        { text: this.$t('display/logs:email-log.to'), value: 'to' },
        { text: this.$t('display/logs:email-log.subject'), value: 'subject' },
        { text: this.$t('display/logs:email-log.message'), value: 'body' },
        { text: this.$t('common:result'), value: 'result' },
        { text: "", value: "controls", sortable: false }
      ]
    },
    trueFalseDecorateFields() {
      return ['status']
    }
  },
  methods: {
    showDetails(item) {
      this.$refs.dialogShow.initialization(item);
    },
    updateTable(options, search) {
      if (!search) search = '';

      this.$refs.table.loading = true;
      let filter = {filter24: this.filterHours};

      LogsService.readAllLogsPaginated(
        'email',
        options.page - 1,
        options.itemsPerPage,
        search,
        options.sortBy,
        options.sortDesc,
        filter,
        (response) => {
          if (this.$refs.table !== undefined) {
            response.data.content = DataUtils.parseDataToObjectArray(response.data.content, Log);
            for (let i = 0; i < response.data.content.length; i++) {
              response.data.content[i].id = i;
            }
            this.$refs.table.fillTableData(response.data);
          }
          this.$refs.table.loading = false;
        },
        () => {
          this.$refs.table.loading = false;
          Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('display/logs:advert.media-log-table')}));
        }
      );
    },
    createPanel() {
      let TablePanelComponent = Vue.extend(TablePanel);
      let instance = new TablePanelComponent({
        i18n,
        propsData: { filterValue: this.filterHours }
      });
      instance.$on('customPanelValueUpdated', this.updateFilter);
      return instance;
    },
    updateFilter(value) {
      this.filterHours = value;
      this.$refs.table.callTableUpdate()
    }
  }
}
</script>
